import React from 'react';

const Label = (props) => {
	return (
		<label className={`cp-label ${props.className}`}>
			{props.children}
		</label>
	);
};

export default Label;


// WEBPACK FOOTER //
// ./src/views/components/generic/label/Label.jsx